// AUTO-GENERATED
//
// This code was automatically generated.
// It should not be modified by hand. Make changes to template files located at
// `generated/frontend-events`, then re-generate this file with `tracking-gen`.

type ResultType = [string, object]

/**
 * Sign In With Apple
 * Button tapped
 */
export enum SignInWithAppleButtonTappedCta_title {
  'SignUp' = 'signUp',
  'SignIn' = 'signIn',
  'ContinueWithApple' = 'continueWithApple',
}

export type TrackSignInWithAppleButtonTappedType = {
  screen: string
  ctaTitle: SignInWithAppleButtonTappedCta_title
}

export const trackSignInWithAppleButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'signInWithAppleButton',
    screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Button Viewed
 */
export enum SignInWithAppleButtonViewedCta_title {
  'SignUp' = 'signUp',
  'SignIn' = 'signIn',
  'ContinueWithApple' = 'continueWithApple',
}

export type TrackSignInWithAppleButtonViewedType = {
  screen: string
  ctaTitle: SignInWithAppleButtonViewedCta_title
}

export const trackSignInWithAppleButtonViewedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleButtonViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Button Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'signInWithAppleButtonContainer',
    screen,
    cta_title: ctaTitle,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Exists Modal Viewed
 */
export type TrackSignInWithAppleAccountExistsModalViewedType = {
  screen: string
}

export const trackSignInWithAppleAccountExistsModalViewedPayload = ({
  screen,
}: TrackSignInWithAppleAccountExistsModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Exists Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationAppleSSOExists',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Exists Modal Dismissed
 */
export type TrackSignInWithAppleAccountExistsModalDismissedType = {
  screen: string
}

export const trackSignInWithAppleAccountExistsModalDismissedPayload = ({
  screen,
}: TrackSignInWithAppleAccountExistsModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Exists Modal Dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAppleSSOExistsDismissed',
    screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Account Suspended Modal Viewed
 */
export type TrackSignInWithAppleAccountSuspendedModalViewedType = {
  screen: string
}

export const trackSignInWithAppleAccountSuspendedModalViewedPayload = ({
  screen,
}: TrackSignInWithAppleAccountSuspendedModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Suspended Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationAppleSSOAccountSuspended',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Suspended Modal Button Tapped
 */
export type TrackSignInWithAppleAccountSuspendedModalButtonTappedType = {
  screen: string
  ctaTitle: string
}

export const trackSignInWithAppleAccountSuspendedModalButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleAccountSuspendedModalButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Suspended Modal Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAppleSSOAccountSuspendedCta',
    screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}
